module.exports = __webpack_public_path__ + "img/pc-footer-bg.f6038189.png";